import React, { Component } from 'react';
import tinycolor from 'tinycolor2'
import * as d3 from 'd3';

import Button from '../components/Button';
import RadioToggle from '../components/RadioToggle';
import SpeciesAvatar from '../components/SpeciesAvatar'
import Dialogue from '../components/Dialogue';

import ChartSpecs from '../data/chart_specs';

var margin = ChartSpecs.chartspecs.marginAreabars;


const species = ChartSpecs.species;
const totalSpecies = species.length;

var colorRange = d3.quantize(d3.interpolateHcl("#f4e153", "#362142"), totalSpecies)

var popularSpeices = ['Bear cub', 'Cat', 'Deer', 'Dog', 'Octopus', 'Rabbit', 'Squirrel','Wolf'].sort((a,b)=>a.localeCompare(b))
var unpopularSpeices = ['Bull', 'Anteater', 'Lion', 'Mouse', 'Pig', 'Gorilla', 'Hippo', 'Kangaroo', 'Chicken', 'Cow', 'Tiger', 'Monkey'].sort((a,b)=>a.localeCompare(b))



class VillagerSpecies extends Component {
  constructor(props){
      super(props);

      this.state = {
        selectedTier:1,
        selectedUnPopularTier:10,
      }

      this.allVillagers = this.props.villagers;
      this.dataSet = [];
      this.colorWheelObjSpecies = {};

      this.sliderRangeHandler = this.sliderRangeHandler.bind(this);
   }

   componentDidMount() {

     this.tierNodes = d3.groups(this.allVillagers, d => d.tier, d => d.species);
     this.tierNodes2 = d3.rollup(this.allVillagers, v => v.length, d => d.tier, d => d.species);
     this.tierArray = [...this.tierNodes2.keys()];

     this.drawChart(popularSpeices, 'popularSpeicesChart');
     this.drawChart(unpopularSpeices, 'unPopularSpeicesChart');
   }

    drawChart(selectedSpeices, svgId){

      let svg = d3.select(`#${svgId}`);

      var chartWidth = svg.node().getBoundingClientRect().width,
          singleChartHeight = 40,
          stackKeys = selectedSpeices,
          radius = 40,
          strokeColor = 'rgba(1,124,116,1)',
          fillColor = 'rgba(1,124,116,0.5)',
          fillColorLight = 'rgba(1,124,116,0.1)',
          totalBarGroups = selectedSpeices.length,
          noOfColumns = 2;

          const defs = svg.append("defs");

          const gradient = defs.append("linearGradient").attr("id", `svgGradient${svgId}`);
          const gradientResetPercentage = "50%";

          gradient
            .append("stop")
            .attr("class", "start")
            .attr("offset", gradientResetPercentage)
            .attr("stop-color", fillColorLight);

          gradient
            .append("stop")
            .attr("class", "start")
            .attr("offset", gradientResetPercentage)
            .attr("stop-color", fillColor);

          gradient
            .append("stop")
            .attr("class", "end")
            .attr("offset", gradientResetPercentage)
            .attr("stop-color", fillColor)
            .attr("stop-opacity", 1);

          gradient
            .append("stop")
            .attr("class", "end")
            .attr("offset", gradientResetPercentage)
            .attr("stop-color", fillColorLight);


      let  tierNodes2 = this.tierNodes2,
           tierArray = this.tierArray,
           noOfChartsPerCol = Math.round(totalBarGroups/noOfColumns);


       let chartHeight = singleChartHeight*totalBarGroups;

       svg.attr("height", chartHeight+margin.top*2);

                this.dataSet = Array.from(tierNodes2.entries())
                 .map(g => {
                   const obj = {};
                   obj["tier"] = g[0];
                   for (let col of stackKeys) {
                     const vals = g[1].get(col);
                     obj[col] = !vals ? 0 : vals;
                   }
                   return obj;
                 })
                .sort((a, b) => a["tier"] - b["tier"]);


                let tableData = this.dataSet;

                const yMaxArray = stackKeys.map(species => {
                  let max = d3.max(tableData, d => d[species])
                  return max;
                });



                 const yMax = d3.max(yMaxArray, d => d);


                 const xScale = d3.scaleBand()
                                 .domain(tierArray)
                                 .range([margin.left, chartWidth/noOfColumns - margin.right])
                                 //.padding(0.5)

                 const yScale = d3.scaleLinear()
                                 .domain([ 0, 8]) //to maintain the same chartHeight, force the domain range to match the popularSpeices chart
                                 .range([singleChartHeight, margin.top/singleChartHeight]);

                 const xAxis = g => g
                             .call(d3.axisBottom(xScale).tickFormat((d,i) => {
                              return (i%9 !== 0)  ? " ": `T.${d}` ;
                             }).tickSizeOuter(0))
                             .call(g => g.selectAll(".domain").remove());

                 const yAxis = g => g
                           .call(d3.axisLeft(yScale).tickValues([0,4,8]).tickSizeOuter(0).tickFormat(y => `${y.toFixed(0)}`))
                           .call(g => g.selectAll(".domain").remove());

                 // Creating the clone of the array
                 let clonetableData = tableData.slice(0);

                 const clonetableDataArr = tableData.map(d => ({ ...d}));

                 // Extract the array using splice method
                 let tableDataExtended = clonetableDataArr.splice(0,tierArray.length);

                 const clonetableDataFirst = tableDataExtended[0];
                 const clonetableDataLast = tableDataExtended[tierArray.length-1];

                 //let tableDataExtended = tableData.slice();

                 tableDataExtended.unshift(clonetableDataFirst);
                 tableDataExtended.push(clonetableDataLast);

                 let newFirst = tableDataExtended[0],
                     newLast = tableDataExtended[tableDataExtended.length-1];

                 stackKeys.forEach((species, index) => {


                   // define the area
                   let area = d3.area()
                       //.x(d => xScale(d.tier))
                       .x((d,i) => {
                         if(i === 0){
                           return xScale.bandwidth()/2 + margin.left/2
                         }else if(i === (tableDataExtended.length-1)){
                           return xScale(d.tier) + xScale.bandwidth()/2
                         }else{
                           return xScale(d.tier)
                         }
                       })
                       .y0(yScale(0))
                       .y1(d => yScale(d[species]))
                       //.y1(d => d.tier === "Start" ? yScale(d[sign]) : yScale(d[sign]))
                       .curve(d3.curveStep)

                   // define the line
                   let line = d3.line()
                             //.x(d => xScale(d.tier))
                             .y(d => yScale(d[species]))
                             .x((d,i) => {
                               if(i === 0){
                                 return xScale.bandwidth()/2 + margin.left/2
                               }else if(i === (tableDataExtended.length-1)){
                                 return xScale(d.tier) + xScale.bandwidth()/2
                               }else{
                                 return xScale(d.tier)
                               }
                             })
                             //.y(d => d.tier === "Start" ? yScale(d[firstSign]) : yScale(d[sign]))
                             .curve(d3.curveStep)



                  let group = svg.append("g")
                    .attr('class', `path-${(species.indexOf(' ') >= 0)?species.replace(/ /g,"-"):species}`); //add dash in Bear cub to generate right class name

                  let barLabels = svg.append("g")
                      .attr('class', `bar-label-${(species.indexOf(' ') >= 0)?species.replace(/ /g,"-"):species}`)

                  let chartLabels = svg.append("g")
                      .attr('class', `chart-label-${(species.indexOf(' ') >= 0)?species.replace(/ /g,"-"):species}`)

                  // Add the area
                  group.append('path')
                      .datum(tableDataExtended)
                      .attr('class', `path-goodlooking`)
                      .style('fill', `url(#svgGradient${svgId})`)
                      .attr("d",area)

                 // Add the line
                  group.append("path")
                     .datum(tableDataExtended)
                     .attr("fill", "none")
                     .attr("stroke", strokeColor)
                     .attr("stroke-width", 2)
                     .attr("d", line)

                  let labelImg = (species === 'Cow' || species === 'Bull')?'Bovine':species;


                   chartLabels.append('text')
                       .attr('class', 'chart-label')
                       .attr("x", d => 0)
                       .attr('y', d => yScale(yMax/2))
                       .attr("dy", "0em")
                       .text(d => `${species}`);

                  let xAxisFixes = (totalBarGroups === 12)?(chartHeight + margin.top/1.25):(chartHeight + margin.top/4);


                   if(index < noOfChartsPerCol){
                     svg.append("g")
                     .attr("transform", `translate(${-margin.right/6}, ${xAxisFixes})`)
                     .attr("class", 'xaxis tier-axis no-tick gap-tick')
                     .call(xAxis);

                     svg.append("g")
                     .attr("transform", `translate(${margin.left/1.25}, ${margin.top/noOfColumns + index*(chartHeight/noOfChartsPerCol)+ index*margin.top/4})`)
                     .attr("class", 'yaxis')
                     .call(yAxis);

                     if(svgId ==='popularSpeicesChart'){
                        chartLabels.attr("transform", `translate(${chartWidth/noOfColumns - margin.right}, ${(margin.top/10)+ index*(chartHeight/noOfChartsPerCol) + index*margin.top/4}) rotate(0)`)
                        .attr("text-anchor", "end")
                     }else{
                        chartLabels.attr("transform", `translate(${margin.right}, ${(-margin.top/10)+ index*(chartHeight/noOfChartsPerCol) + index*margin.top/4}) rotate(0)`)
                        .attr("text-anchor", "start")
                     }


                     group.attr("transform", `translate(${0  + margin.right/6}, ${margin.top/2 + index*(chartHeight/noOfChartsPerCol)+ index*margin.top/4})`)

                     barLabels.attr("transform", `translate(${chartWidth/noOfColumns - margin.right/2.25}, ${margin.top/1.5 + index*(chartHeight/noOfChartsPerCol)+index*margin.top/4}) rotate(0)`)

                   }else{
                     svg.append("g")
                     .attr("transform", `translate(${chartWidth/noOfColumns-margin.right/6}, ${xAxisFixes})`)
                     .attr("class", 'xaxis tier-axis no-tick gap-tick')
                     .call(xAxis);

                    svg.append("g")
                     .attr("transform", `translate(${chartWidth/noOfColumns + margin.left/1.25}, ${margin.top/noOfColumns + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol) + (index-noOfChartsPerCol)*margin.top/4})`)
                     .attr("class", 'yaxis')
                     .call(yAxis);

                     if(svgId ==='popularSpeicesChart'){
                       chartLabels.attr("transform", `translate(${chartWidth - margin.right}, ${(margin.top/10) + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*margin.top/4}) rotate(0)`)
                       .attr("text-anchor", "end")

                    }else{
                       chartLabels.attr("transform", `translate(${chartWidth/noOfColumns + margin.right}, ${(-margin.top/10) + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*margin.top/4}) rotate(0)`)
                       .attr("text-anchor", "start")
                    }

                     group.attr("transform", `translate(${chartWidth/noOfColumns + margin.right/6}, ${margin.top/2 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+(index-noOfChartsPerCol)*margin.top/4})`)

                     barLabels.attr("transform", `translate(${chartWidth - margin.right/2.25}, ${margin.top/1.5 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+(index-noOfChartsPerCol)*margin.top/4}) rotate(0)`)

                   }

          });

          if(svgId ==='popularSpeicesChart'){
             this.highlightTierBar(this.state.selectedTier, svgId);
          }else{
             this.highlightTierBar(this.state.selectedUnPopularTier, svgId);
          }

    }


    sliderRangeHandler(event, chartId){
       let selectedTier = event.target.value;

       if(chartId ==='popularSpeicesChart'){
          this.setState({selectedTier: selectedTier});
       }else{
         this.setState({selectedUnPopularTier: selectedTier});
       }

       this.highlightTierBar(selectedTier, chartId);
    }

    highlightTierBar(selectedTier, chartId){
      let selectedGroup = (chartId ==='popularSpeicesChart')?popularSpeices:unpopularSpeices;

      let tableData = this.dataSet,
          tierArray = this.tierArray,
          totalBarGroups = selectedGroup.length,
          stackKeys= selectedGroup,
          noOfColumns = 2;

      let svg = d3.select(`#${chartId}`);
      let chartHeight = svg.node().getBoundingClientRect().height,
          chartWidth = svg.node().getBoundingClientRect().width;

      let noOfChartsPerCol = Math.round(totalBarGroups/noOfColumns);


      const yMaxArray = stackKeys.map(sign => {
        let max = d3.max(tableData, d => d[sign])
        return max;
      });

       const yMax = d3.max(yMaxArray, d => d);


      const xScale = d3.scaleBand()
                      .domain(tierArray)
                      .range([0, chartWidth/noOfColumns - margin.right])
                      //.padding(0.5)

      const yScale = d3.scaleLinear()
                      .domain([ 0, yMax])
                      .range([chartHeight/noOfChartsPerCol - margin.top, margin.top/noOfChartsPerCol])


       // Get the index of the xValue relative to the dataSet
       const dataIndex = tableData.findIndex(obj => obj.tier === Number(selectedTier))

     //  const leftData = (dataIndex === 0)? 0 :tableData[dataIndex-1];
       const leftData = tableData[dataIndex];
       const rightData = (dataIndex === 9)? 'max':tableData[dataIndex + 1];

       if(rightData === 'max'){
           svg.selectAll(".start").attr("offset", `${90}%`);
           svg.selectAll(".end").attr("offset", `${100}%`);
         }else{
           // Update gradient
           const x1Percentage = xScale(leftData.tier) / (chartWidth/noOfColumns - margin.right)  * 100;
           const x2Percentage = xScale(rightData.tier) / (chartWidth/noOfColumns - margin.right)  * 100;
           svg.selectAll(".start").attr("offset", `${x1Percentage}%`);
           svg.selectAll(".end").attr("offset", `${x2Percentage}%`);
         }
    }




  render() {
    let allVillagersGroupedBySpecies = d3.group(this.allVillagers, d => d.species);
    let topVillagers = this.allVillagers.filter(v => v.Average_Popularity_Ranking <= 40);
    let topVillagersGroupedBySpecies = d3.group(topVillagers, d => d.species);


    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-traits">
        <h2 className="title">Villager species</h2>
        <p className="paragraph">There are many species of villagers in Animal Crossing, from cats and dogs to more exotic species like hippos and koalas. We wanted to know whether certain species were more popular than others.</p>
        <p className="paragraph">Out of the 35 species, we highlighted the species with the most significant trends. </p>
        <h3 className="sub-title space-top">Popular Villagers</h3>
        <p className="paragraph haspointer"> All of the "popular" species are represented in the top 40 villagers. Other than <b>Deer</b> and <b>Rabbit</b>, all of the other "popular" species are not found at all in Tiers 8-10. </p>
        <div className='tier-slider'>
            <label htmlFor="speicesTierSlider" className='slider-label' aria-label="Tier slider"></label>
            <input type="range"
            id="speicesTierSlider"
            min="1"
            max="10"
            value={this.state.selectedTier}
            onChange={(e) => this.sliderRangeHandler(e,'popularSpeicesChart')}
            step="1"
            className='slider-input'/>
            <output htmlFor="speicesTierSlider" id="speicesTierSlider-output" style={{left: `calc(${parseInt(this.state.selectedTier)*10}% - ${(parseInt(this.state.selectedTier)/10)*72}px - ${3.9*(10-parseInt(this.state.selectedTier))}px)`}} className='slider-output'>Tier {this.state.selectedTier}</output>
        </div>
        <svg id='popularSpeicesChart' width="100%"></svg>


        <h3 className="sub-title space-top">Unpopular Villagers</h3>
        <p className="paragraph">All of the species shown here have little to no representation in Tiers 1-4. <b>Mouse</b>, <b>Pig</b>, and <b>Gorilla</b> in particular exhibited a very strong trend of increasing numbers from Tier 8-10. </p>
        <div className='tier-slider'>
            <label htmlFor="unspeicesTierSlider" className='slider-label' aria-label="Tier slider"></label>
            <input type="range"
            id="unspeicesTierSlider"
            min="1"
            max="10"
            value={this.state.selectedUnPopularTier}
            onChange={(e) => this.sliderRangeHandler(e,'unPopularSpeicesChart')}
            step="1"
            className='slider-input'/>
            <output htmlFor="unspeicesTierSlider" id="unspeicesTierSlider-output" style={{left: `calc(${parseInt(this.state.selectedUnPopularTier)*10}% - ${(parseInt(this.state.selectedUnPopularTier)/10)*72}px - ${3.9*(10-parseInt(this.state.selectedUnPopularTier))}px)`}} className='slider-output'>Tier {this.state.selectedUnPopularTier}</output>
        </div>
        <svg id='unPopularSpeicesChart' width="100%"></svg>

        <Dialogue title="Summary" type="regular">
          <p className="paragraph"> A villager’s species may affect its popularity, particularly if they are one of the 8 “popular” species or 12 “unpopular” species. </p>
        </Dialogue>
      </div>


    )
  }
}

export default VillagerSpecies;
